module.exports = __webpack_public_path__ + "static/media/img-logo-horizontal@2x.855f9662.jpg";